import React from 'react'
import {Router, Route, browserHistory,IndexRoute} from 'react-router'
import Home from './pages/Home';
import Art from './pages/Art';
import App from './pages/App';
import Contact from './pages/Contact'
import News from './pages/News'
import NewsContent from './pages/NewsContent'
import Story from './pages/Story'


import Exhibition from './pages/Exhibition';
import ArtGalleryDesktop from './components/ArtGalleryDesktop'
export default(
    <Router history={browserHistory}>
        <Route path="/" title="Silver Koppel" component={App}>
              <IndexRoute component={Home}/>
              <Route path="/art" component={Art}/>
              <Route path="/news" component={News}/>
              <Route path="/story" component={Story}/>
              <Route path="/contact(/:subject)" component={Contact}/>
              <Route path="/art/:art(/:painting)" component={Exhibition}/>
              <Route path="/news/:news" component={NewsContent}/>
              <Route path='*' component={Home}/>
        </Route>

    </Router>
)



// WEBPACK FOOTER //
// ./src/router.jsx